import MainVisualVideo from '../../../assets/images/mv_video.mp4';

export default function MainVisual() {
  return (
    <>
      <video className="main_video w-100" autoPlay loop muted playsInline>
        <source src={MainVisualVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </>
  );
}
